module.exports = __webpack_public_path__ + "img/DZ.7682fcef.svg";